import { useEffect } from "react";
import Emitter from "../utils/emitter";

export function useGlobalLoading(name: string, isLoading: boolean | undefined) {
	useEffect(() => {
		Emitter.emit("loading", { name, isLoading: !!isLoading });
		return () => {
			Emitter.emit("loading", { name, isLoading: false });
		};
	}, [name, isLoading]);
}
